import type { RouteRecordRaw } from 'vue-router'

export const requestChatsRoutes: RouteRecordRaw[] = [
  {
    path: '/chats',
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: routeNames.requestChatsList,
        component: () => import('@/views/request-chats/RequestChatsList.vue')
      }
    ]
  },
  {
    path: '/chats/:chatId',
    component: () => import('@/layouts/BlankLayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: routeNames.requestChatDetail,
        component: () => import('@/views/request-chats/RequestChatDetail.vue')
      }
    ]
  }
]
